<div class="address">
  {{ address }}
  <i *ngIf="linkAddress" (click)="openMaps()" class="fal fa-external-link-square-alt"></i>
</div>
